module.exports = __webpack_public_path__ + "img/bar-chart-grouped-light-02.df99d309.jpg";